export default __webpack_public_path__ + "static/media/PurpleLabIndividualId.1e3ab9c5.csv";